import request from '@/plugins/axios'

// 获取指定认证服务
export function urlApi(provider_name) {
  return request({
    url: `/authentication/auth_provider/${provider_name}`,
    method: 'get',
  })
}
// 认证登录
export function loginApi(data) {
  return request({
    url: `/authentication/auth_provider_login`,
    method: 'post',
    data
  })
}
